module.exports = __webpack_public_path__ + "static/media/Yoga.42258713.jpg";